document.addEventListener('DOMContentLoaded', () => {

    const items = document.querySelectorAll('.exxtra-faq-item');

    items.forEach(item => {

        const button = item.querySelector('.exxtra-faq-item__question');

        button.addEventListener('click', () => {

            const isOpen = item.classList.contains('is-open');

            items.forEach(i => i.classList.remove('is-open'));

            if (!isOpen) {
                item.classList.add('is-open');
            }

        });

    });

});